/**
 * apps/command/src/screens/PhasePlaceholder.tsx — the honest "not yet" screen.
 *
 * ============================================================================
 * WHY A PLACEHOLDER SCREEN EXISTS AT ALL, AND WHAT MAKES IT HONEST.
 * ============================================================================
 *
 * §15.7 gives an `hr` account an attendance home and a `content` account a
 * broadcast home. Those modules are P3 and P2. The options were: leave those
 * roles with no home (they would land on a 404 or bounce to a screen they
 * cannot read), draw the screen empty (indistinguishable from a fault), or say
 * what is true.
 *
 * So it says what is true, and it names the PHASE — «P2 bosqichida» — because
 * "coming soon" is what software says when nobody has decided, and an official
 * who is told a phase can ask when that phase lands.
 *
 * It carries no fake controls. §15.10's "a no-data state that says *why* there
 * is no data, never an empty box" is the same instinct one level up: a screen
 * that has no data because it has not been built yet must say so, not mime a
 * working one.
 */
import { t } from '../i18n/index.js';
import { Panel } from '../ui/index.jsx';

export function PhasePlaceholder({ noteKey }: { noteKey: string }): React.JSX.Element {
  return (
    <Panel className="px-6 py-10">
      <h2 className="text-lead font-medium text-ink-100">{t('phase.title')}</h2>
      <p className="mt-2 text-label text-ink-300">{t(noteKey)}</p>
      <p className="mt-1 text-micro text-ink-500">{t('phase.note')}</p>
    </Panel>
  );
}
